
import { Box } from "@mui/material";

export default function PaidStep({handleStep}:{handleStep:(stepNum:number)=>void}){
  //I can edit
  // I can save and it will move it to waiting for approval
return (<Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
    <Box sx={{ flex: '1 1 auto' }} />
    {/* <Button onClick={()=>handleStep(StepsEnum.Closed)}>
      {'Close'}
    </Button> */}
  </Box>)
}